import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import BaseLayout from 'ui/layout/BaseLayout';
import AppRoutes, { HOME_ROUTE } from 'config/AppRoutes';
import PageAddress from 'pages/PageAddress/PageAddress';
import PageMap from 'pages/PageMap/PageMap';
import PagePanel from 'pages/PagePanel/PagePanel';
import PageConsumption from 'pages/PageConsumption/PageConsumption';
import PageBillInfo from 'pages/PageBill/PageBillInfo';
import PageBatteryOption from 'pages/PageBatteryOption';
import PageElectricVehicle from 'pages/PageElectricVehicle';
import PageSummary from 'pages/PageSummary';
import PageBillInfoDefault from 'pages/PageBill/PageBillInfoDefault';
import PageThanks from 'pages/PageThanks';
import PageRoofAngle from 'pages/PageRoofAngle';
import PageCounter from 'pages/PageCounter/PageCounter';
import PageRoofType from 'pages/PageRoofType';
import PageEstimate from 'pages/PageEstimate';
import { PageWithApiItems } from 'components/PageWithApiItems';
import FlowChoice from 'pages/FlowChoice/FlowChoice';
import PageBusinessChoice from 'pages/PageBusinessChoice/PageBusinessChoice';
import PageExtraServices from 'pages/PageExtraServices/PageExtraServices';
import PageSMEContact from 'pages/PageSMEContact/PageSMEContact';

const App = () => (
  <HashRouter>
    <BaseLayout>
      <Routes>
        <Route path="/" element={<Navigate to={HOME_ROUTE} />} />
        <Route
          path={AppRoutes.BUSINESS_CHOICE}
          element={<PageBusinessChoice />}
        />
        <Route path={AppRoutes.FLOW_CHOICE} element={<FlowChoice />} />
        <Route path={AppRoutes.ADDRESS_CHOICE} element={<PageAddress />} />
        <Route path={AppRoutes.PANEL_SELECTION} element={<PagePanel />} />
        <Route path={AppRoutes.ROOF_ANGLE} element={<PageRoofAngle />} />
        <Route path={AppRoutes.ROOF_TYPE} element={<PageRoofType />} />

        <Route
          path={AppRoutes.MAP_SYSTEM}
          element={
            <PageWithApiItems>
              <PageMap />
            </PageWithApiItems>
          }
        />
        <Route
          path={AppRoutes.CONSUMPTION}
          element={
            <PageWithApiItems>
              <PageConsumption />
            </PageWithApiItems>
          }
        />
        <Route
          path={AppRoutes.SME_CONTACT}
          element={
            <PageWithApiItems>
              <PageSMEContact />
            </PageWithApiItems>
          }
        />
        <Route
          path={AppRoutes.BILL_INFO}
          element={
            <PageWithApiItems>
              <PageBillInfo />
            </PageWithApiItems>
          }
        />
        <Route
          path={AppRoutes.BILL_INFO_DEFAULT}
          element={
            <PageWithApiItems>
              <PageBillInfoDefault />
            </PageWithApiItems>
          }
        />

        <Route path={AppRoutes.COUNTER} element={<PageCounter />} />
        {/* <Route path={AppRoutes.INVERTER} element={<PageInverter />} /> */}

        <Route
          path={AppRoutes.BATTERY_OPTION}
          element={<PageBatteryOption />}
        />
        <Route
          path={AppRoutes.ELECTRIC_VEHICLE}
          element={<PageElectricVehicle />}
        />
        <Route
          path={AppRoutes.EXTRA_SERVICES}
          element={<PageExtraServices />}
        />
        <Route
          path={AppRoutes.SUMMARY}
          element={
            <PageWithApiItems>
              <PageSummary />
            </PageWithApiItems>
          }
        />
        <Route path={AppRoutes.THANKS} element={<PageThanks />} />
        <Route path={AppRoutes.ESTIMATE} element={<PageEstimate />} />
      </Routes>
    </BaseLayout>
  </HashRouter>
);

export default App;
